import { TabletMockup } from "./TabletMockup";
import { useLanguage } from "../i18n/LanguageContext";
import { ChipText, TitleLines } from "../i18n/text";

type HeroSectionProps = {
    onOpenContactForm: () => void;
};

export function HeroSection({ onOpenContactForm }: HeroSectionProps) {
    const { t } = useLanguage();

    return (
        <section className="section heroSection" id="features">
            <div className="sectionText heroText">
                <p className="eyebrow">{t.hero.eyebrow}</p>

                <h1>
                    <TitleLines lines={t.hero.titleLines} />
                </h1>

                <p className="lead">{t.hero.lead}</p>

                <div className="actions">
                    <button className="primaryButton" type="button" onClick={onOpenContactForm}>
                        {t.hero.requestDemo} <span>→</span>
                    </button>

                    <a className="secondaryButton" href="#how">
                        <span className="playIcon">▶</span> {t.hero.watchScenario}
                    </a>
                </div>

                <div className="featureChips">
                    <div>
                        <span>▯</span>
                        <ChipText text={t.hero.chipTablet} />
                    </div>

                    <div>
                        <span>▭</span>
                        <ChipText text={t.hero.chipPay} />
                    </div>

                    <div>
                        <span>≡</span>
                        <ChipText text={t.hero.chipCustomize} />
                    </div>
                </div>
            </div>

            <div className="heroVisual">
                <div className="magicPath" />

                <div className="floatingCard floatingCardMenu">
                    <span className="floatingIcon">🍽</span>
                    <strong>{t.hero.cardMenuTitle}</strong>
                    <p>{t.hero.cardMenuText}</p>
                </div>

                <div className="floatingCard floatingCardOrder">
                    <span className="floatingIcon">⌂</span>
                    <strong>{t.hero.cardOrderTitle}</strong>
                    <p>{t.hero.cardOrderText}</p>
                </div>

                <div className="floatingCard floatingCardPay">
                    <span className="floatingIcon">▭</span>
                    <strong>{t.hero.cardPayTitle}</strong>
                    <p>{t.hero.cardPayText}</p>
                </div>

                <TabletMockup />
            </div>
        </section>
    );
}
